// @core/api/endpoints/webhook/get_endpoint.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  EndpointResponse,
} from '../../../types/webhook';

const BASE_PATH = '/webhook';

/**
 * Get webhook endpoint
 * Retrieves the configuration details of a specific webhook endpoint including its URL, subscribed events, and status.
 */
export async function GetEndpoint(
  endpoint_id: string,
  options?: RequestOptions
): Promise<EndpointResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/endpoints/:endpoint_id`;
  requestPath = requestPath.replace(':endpoint_id', encodeURIComponent(endpoint_id));
  const requestOptions = options;
  return client.get<EndpointResponse>(requestPath, { ...requestOptions });
}
